export const TALKING_POINT_STATUSES = {
  PENDING: 'Pending',
  DISCUSSED: 'Discussed',
  SKIPPED: 'Skipped',
};

export const getStatusColor = (status) => {
  switch (status) {
    case TALKING_POINT_STATUSES.PENDING:
      return '#F3F4F6';
    case TALKING_POINT_STATUSES.DISCUSSED:
      return '#DCFCE7';
    case TALKING_POINT_STATUSES.SKIPPED:
      return '#FEF3C7';
    default:
      return '#F3F4F6';
  }
};

export const getStatusTextColor = (status) => {
  switch (status) {
    case TALKING_POINT_STATUSES.PENDING:
      return '#6B7280';
    case TALKING_POINT_STATUSES.DISCUSSED:
      return '#16A34A';
    case TALKING_POINT_STATUSES.SKIPPED:
      return '#D97706';
    default:
      return '#6B7280';
  }
};

export const getStatusText = (status) => {
  switch (status) {
    case TALKING_POINT_STATUSES.PENDING:
      return 'Pending';
    case TALKING_POINT_STATUSES.DISCUSSED:
      return 'Discussed';
    case TALKING_POINT_STATUSES.SKIPPED:
      return 'Skipped';
    default:
      return 'Pending';
  }
};
